import { storeToRefs } from 'pinia'
import { useErrorStore } from '@/stores/error'

export function useAppErrors() {
  const errorStore = useErrorStore()
  const { getErrors } = storeToRefs(errorStore)

  return {
    getErrors,
    setUIError: errorStore.setUIError,
    setApiError: errorStore.setApiError,
    clearErrors: errorStore.clearErrors,
    removeError: errorStore.removeError,
    getErrorsBySource: errorStore.getErrorsBySource,
  }
}
